import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const Settings = z.object({
  id: z.string(),
  activityId: z.string(),
  integrationId: z.string(),
  namingConventionId: z.string().optional().nullish(), // TODO: Remove nullish with ff.namingConventionV3
});

export const SettingsResponseSchema = createResponseSchema(Settings);
